import { memo } from "react";

function GOR() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.7158 1.71582L1.71582 27.7158L0.28418 26.2842L26.2842 0.28418L27.7158 1.71582Z"
        fill="currentColor"
      />
      <path
        d="M28 22.4507C28 25.5155 25.5376 28 22.5 28C19.4624 28 17 25.5155 17 22.4507C17 19.3859 22.5 13 22.5 13C22.5 13 28 19.3859 28 22.4507Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9879 9.57094C10.7975 6.44781 5.41303 0 5.41303 0C4.19513 5.55575 -0.00486251 6.18879 4.22598e-06 9.84604C0.00304594 12.3139 1.10415 13.7468 2.47778 14.5079C2.04282 13.0297 2.21924 11.3142 3.52535 10.0742C5.93682 7.78435 6.20205 6.24442 6.20205 6.24442C8.69686 10.7455 8.08486 13.5738 7.14497 15C9.43357 14.3577 11.1625 12.4302 10.9879 9.57094Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(GOR);
